module.exports = __webpack_public_path__ + "static/media/introduction.327b01e8.png";